import React from 'react';
import { AppButton, NewTabIcon } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { useMyMoneyReimbursementFeatureFlag } from '@/modules/UseMyMoney/hooks';

import { useGetEmployeeId } from '../hooks';

export const ExpenseDetailsSubmitClaimButton = () => {
  const employeeId = useGetEmployeeId();
  const { isUseMyMoneyReimbursementEnabled } = useMyMoneyReimbursementFeatureFlag();

  return (
    <AppButton
      testId="Redirect_to_reimburse_me_page"
      buttonType="secondary"
      onClick={() => {
        if (isUseMyMoneyReimbursementEnabled) {
          window.open(`${ROUTES.USE_MY_MONEY(employeeId)}${window.location.search}`, '_blank');
          return;
        }
        window.open(`${ROUTES.REIMBURSE_ME(employeeId)}${window.location.search}`, '_blank');
      }}
      rightIcon={<NewTabIcon />}
    >
      Submit Claim
    </AppButton>
  );
};

export default ExpenseDetailsSubmitClaimButton;
